export const arrowUpSVG = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_31795_335645)">
<rect width="24" height="24" transform="matrix(0 -1 1 0 0 24)" fill="white" fill-opacity="0.01"/>
<path d="M6 14.0002L7.41 15.4102L12 10.8302L16.59 15.4102L18 14.0002L12 8.00016L6 14.0002Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_31795_335645">
<rect width="24" height="24" fill="white" transform="matrix(0 -1 1 0 0 24)"/>
</clipPath>
</defs>
</svg>
`;
